import { useDispatch, useSelector } from 'react-redux';
import { TypedUseSelectorHook } from 'react-redux';
import { RootState, AppDispatch } from '../store';

//type rootState = ReturnType<typeof reducer>;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useTypedSelector : TypedUseSelectorHook<RootState> = useSelector;